import { render, staticRenderFns } from "./prescription.vue?vue&type=template&id=287c647f&scoped=true&"
import script from "./prescription.vue?vue&type=script&lang=js&"
export * from "./prescription.vue?vue&type=script&lang=js&"
import style0 from "./prescription.vue?vue&type=style&index=0&id=287c647f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287c647f",
  null
  
)

export default component.exports